import { getUrl } from "../../../../../../../../utils/utils/get-url.js";
function getNameByProductRoute(categoryRoute, page) {
  const menuDocumentRef = page?.getComponent("header", "main-menu")?.getModels().menu;
  const menu = menuDocumentRef && page?.getContent(menuDocumentRef);
  if (!menu?.getItems()) {
    return void 0;
  }
  const route = findRouteByUrl(categoryRoute, menu?.getItems());
  return route && route.getName();
}
function findRouteByUrl(categoryRoute, routes) {
  for (const route of routes) {
    if (route.getLink()?.href && route.getLink()?.href === categoryRoute) {
      return route;
    }
    if (route.getChildren().length) {
      const result = findRouteByUrl(categoryRoute, route.getChildren());
      if (result) return result;
    }
  }
}
function createCategoryBreadcrumb(categoryRoute, page) {
  if (!page) {
    return null;
  }
  const name = getNameByProductRoute(categoryRoute, page);
  const url = getUrl(categoryRoute, page);
  return name ? { name, url } : null;
}
export {
  createCategoryBreadcrumb,
  getNameByProductRoute
};
//# sourceMappingURL=create-category-breadcrumb.js.map
